<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Sicherheit, Komfort und Charakter</h2>
        <div class="flex justify-center">
          <h1 class="headline">Tore</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Ein gutes Tor öffnet sich leise, schließt zuverlässig und passt sich nahtlos in die Architektur ein. Es erfüllt seine Aufgabe mit Stil, Tag für Tag.
        </p>

        <p class="mt-4 text-gray-700">
          Ob ein- oder mehrflügelig, als elegantes Schiebetor oder mit elektrischem Antrieb, wir fertigen Eingangs- und Einfahrtstore individuell nach Maß. Die Gestaltungsmöglichkeiten sind vielseitig: von geschlossenen Ausführungen mit Blechkassetten (auch mit Muster) oder satiniertem Glas bis hin zu offenen Varianten mit Stacheten oder Doppelstabmatten.
        </p>

        <p class="mt-4 text-gray-700">
          Auch funktionale Details, wie Briefkästen, Gegensprechanlagen oder Klingelsysteme, integrieren wir direkt in die Toranlage. Bei der Wahl der Materialien stehen Ihnen verschiedene Optionen offen: verzinkt, pulverbeschichtet, in Edelstahl oder in charaktervollem Cortenstahl mit seiner markanten Rostoptik.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Tore" pixelEvent="FormToreSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/tore/1.jpg", alt: "Tor 1" },
        { src: "img/produkte/tore/2.jpg", alt: "Tor 2" },
        { src: "img/produkte/tore/3.jpg", alt: "Tor 3" },
        { src: "img/produkte/tore/4.jpg", alt: "Tor 4" },
        { src: "img/produkte/tore/5.jpg", alt: "Tor 5" },
        { src: "img/produkte/tore/6.jpg", alt: "Tor 6" },
        { src: "img/produkte/tore/7.jpg", alt: "Tor 7" },
        { src: "img/produkte/tore/8.jpg", alt: "Tor 8" },
        { src: "img/produkte/tore/9.jpg", alt: "Tor 9" },
        { src: "img/produkte/tore/10.jpg", alt: "Tor 10" },
        { src: "img/produkte/tore/11.jpg", alt: "Tor 11" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
